import { useCallback, useState } from 'react';

export const useOrderContext = () => {
  const [order, setOrder] = useState<string[]>([]);

  const register = useCallback(
    (name: string) => {
      if (order.includes(name)) {
        return;
      }
      setOrder((prev) => [...prev, name]);
    },
    [order]
  );
  const updateOrder = useCallback(
    (name: string, newIndex: number) => {
      const newOrder = [...order].filter((item) => item !== name);
      newOrder.splice(newIndex, 0, name);
      setOrder(newOrder);
    },
    [order]
  );
  const getOrder = useCallback(
    (needle: string) => {
      return order.findIndex((name) => needle === name);
    },
    [order]
  );

  return {
    order,
    register,
    getOrder,
    updateOrder,
  };
};
